import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TableFieldCondition, TableFieldConditionArgumentOperator, TableFieldConditionOperator} from '../table-field.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TableFiledConditionOperatorsMap} from '../../../../locale/consts.en';
import {DECIMAL_PATTERN} from '../../../master-data/master-data.model';

@Component({
    selector: 'app-table-filed-condition-dialog',
    templateUrl: './table-field-condition-dialog.component.html',
    styleUrls: ['./table-field-condition-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableFieldConditionDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<TableFieldConditionDialogComponent>>(MatDialogRef);
  data = inject<TableFieldCondition | null>(MAT_DIALOG_DATA);


  TableFieldConditionOp = TableFieldConditionOperator;
  TableFiledConditionOpMap =TableFiledConditionOperatorsMap;
  public conditionForm: FormGroup;

  editMode = false;

  ngOnInit(): void {
    this.createConditionForm();
    this.setDataToForm();
  }

  private createConditionForm() {
    this.conditionForm = this.fb.group({
      expression: ['', [Validators.required]],
      operator: [+TableFieldConditionOperator.OR, [Validators.required]],
      oneArgument: [true],
      argument1: this.fb.group({
        value: [null, [Validators.required, Validators.pattern(DECIMAL_PATTERN)]],
        operator: [+TableFieldConditionArgumentOperator.EQ, [Validators.required]]
      }),
      argument2: this.fb.group({
        value: [Validators.pattern(DECIMAL_PATTERN)],
        operator: [+TableFieldConditionArgumentOperator.EQ]
      }),
      resultTrue: [null, [Validators.required]],
      resultFalse: [null, [Validators.required]]
    });
  }

  setDataToForm() {
    if (this.data != null) {
      this.conditionForm.patchValue({
        expression: this.data.expression,
        operator: this.data.operator,
        oneArgument: this.data.oneArgument,
        resultTrue: this.data.resultTrue,
        resultFalse: this.data.resultFalse,
        argument1: {
          value: this.data.argument1.value,
          operator: this.data.argument1.operator
        }
        }
      );
      if(!this.data.oneArgument) {
        this.conditionForm.patchValue({
          argument2: {
            value: this.data.argument2.value,
            operator: this.data.argument2.operator
          }
        });
      }
    }
    this.setDisableOnArg2Operator();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(this.conditionForm.value);
  }

  onOneArgChange(e: MatCheckboxChange) {
    if (e.checked) {
      (this.conditionForm.controls.argument2 as FormGroup).controls.value.setValidators([]);
      (this.conditionForm.controls.argument2 as FormGroup).controls.operator.setValidators([]);
    } else {
      (this.conditionForm.controls.argument2 as FormGroup).controls.value.setValidators(Validators.required);
      (this.conditionForm.controls.argument2 as FormGroup).controls.operator.setValidators(Validators.required);
    }
    (this.conditionForm.controls.argument2 as FormGroup).controls.value.updateValueAndValidity();
    (this.conditionForm.controls.argument2 as FormGroup).controls.operator.updateValueAndValidity();
    this.setDisableOnArg2Operator();
  }

  setDisableOnArg2Operator() {
    if(this.conditionForm.controls.oneArgument.value) {
      (this.conditionForm.controls.argument2 as FormGroup).controls.operator.disable({onlySelf: true});
    } else {
      (this.conditionForm.controls.argument2 as FormGroup).controls.operator.enable({onlySelf: true});
    }
  }
}
